import {
  HttpHandlerFn,
  HttpHeaderResponse,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MibToastService } from '@medinbox/angular';
import { catchError, Observable, switchMap, take, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { OAuthService } from './oauth.service';
import { GuestService } from './guest.service';
import { UserService } from '@core/services/user.service';

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<
  | HttpSentEvent
  | HttpHeaderResponse
  | HttpProgressEvent
  | HttpResponse<unknown>
  | HttpUserEvent<unknown>
> {
  const authService = inject(OAuthService);
  const guestService = inject(GuestService);
  const userService = inject(UserService);
  const router = inject(Router);
  const toastService = inject(MibToastService);

  // Guest token endpoint isn't protected
  if (req.url === guestService.GUEST_TOKEN_ENDPOINT) {
    return next(req);
  }

  return authService.isLoggedIn().pipe(
    take(1),
    switchMap((isLoggedIn) => {
      if (
        isLoggedIn &&
        (req.url.startsWith(environment.apiUrl) || req.url.startsWith(environment.hubsUrl))
      ) {
        return authService.getAccessToken().pipe(
          switchMap((token) => {
            const authReq = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
            return next(authReq).pipe(
              catchError((error) => {
                // Handle 401 error
                if (error.status === 401 && userService.isGuest()) {
                  toastService.show({
                    message:
                      'Your guest session expired. Please request another guest link or log in.',
                    type: 'warning',
                  });
                  router.navigateByUrl('/logout');
                  return throwError(() => error);
                }
                return throwError(() => error);
              }),
            );
          }),
        );
      }
      return next(req);
    }),
    catchError((error) => {
      return throwError(() => error);
    }),
  );
}
